<template>
  <v-card class="flex flex-column">
    <v-toolbar color="transparent" class="elevation-0">
      <v-toolbar-title>Meine geplanten Beiträge</v-toolbar-title>
    </v-toolbar>

    <v-skeleton-loader
      :loading="loading"
      type="table-heading, list-item-two-line, divider, list-item-two-line, divider, list-item-two-line"
    >
      <v-card-text>
        <v-simple-table
          class="my-0"
          primary
          v-if="!loading && articles.length > 0"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Datum
                </th>
                <th class="text-left">
                  Arbeitstitel
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="article in articles" :key="article.id">
                <td class="text-left">
                  {{
                    new Date(article.assigned_date).toLocaleDateString("en-CH")
                  }}
                </td>
                <td class="text-left">
                  <template v-for="topic in topics">
                    {{ topic.id == article.content_topic ? topic.name : "" }}
                  </template>
                </td>
                <td class="text-center">
                  <v-btn @click="createArticle(article)">
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <template v-else>
          <div class="d-flex justify-center">
            <v-icon size="140">mdi-archive-outline</v-icon>
          </div>
          <div class="d-flex justify-center text-h6">
            Für Sie sind keine weiteren Beiträge geplant
          </div>
        </template>
      </v-card-text>
    </v-skeleton-loader>

    <DialogArticleNew
      :dialog="newArticleDialog"
      :selectedPlan="selectedPlan"
      @saved="close"
      @close="close"
    />
  </v-card>
</template>

<script>
import DialogArticleNew from "@/components/articles/DialogArticleNew"

import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const TopicsRepository = RepositoryFactory.get("topics")
const PlannedArticlesRepository = RepositoryFactory.get("plannedArticles")

export default {
  name: "PlannedArticlesWidget",
  props: {
    loading: Boolean,
    selectedProject: Object,
  },
  components: {
    DialogArticleNew,
  },
  data() {
    return {
      selectedPlan: {},
      newArticleDialog: false,
      allPlannedArticles: [],
      articles: [],
      topics: [],
      authors: [],
    }
  },
  async created() {
    const { data: topicsData } = await TopicsRepository.getContentTopics()
    this.topics = topicsData

    const {
      data: plannedArticlesData,
    } = await PlannedArticlesRepository.getByWriter(this.$store.state.user.id)
    this.allPlannedArticles = plannedArticlesData
    this.articles = plannedArticlesData
      .filter((article) => article.project == this.selectedProject.id)
      .filter((article) => article.reused_article == null)
  },
  watch: {
    selectedProject: function() {
      this.articles = this.allPlannedArticles.filter(
        (article) => article.project == this.selectedProject.id
      )
    },
  },
  methods: {
    createArticle(article) {
      this.selectedPlan = article
      this.newArticleDialog = true
    },
    async close() {
      this.$emit("dialogClosed")
      this.newArticleDialog = false
      this.selectedPlan = {}

      const {
        data: plannedArticlesData,
      } = await PlannedArticlesRepository.getByWriter(this.$store.state.user.id)

      this.articles = plannedArticlesData
        .filter((article) => article.project == this.selectedProject.id)
        .filter((article) => article.reused_article == null)
    },
  },
}
</script>

<style scoped></style>
